import React, { Component } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Layout, Menu, Select, Icon, Dropdown, Button } from 'antd';
import { SideBar } from './common/molecules';
import HelpApi from '../services/help.api';
import handleAppError from './handlers/handleAppError';
import { utilizationApi } from '../services';
import NavBar from './NavBar';

const { Content } = Layout;
const SubMenu = Menu.SubMenu;
const Option = Select.Option;

window.axios = axios.create({
  headers: {
    common: {
      'X-EKINCARE-KEY': sessionStorage.getItem('axiosHeaders'),
      'X-COMPANY-ID': sessionStorage.getItem('company_id'),
    },
  },
});
class MainLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: true,
      redirect: false,
      role: sessionStorage.getItem('role'),
      drawerflag: false,
      initialKey: null,
      help_data: null,
      digitization: sessionStorage.getItem('digitization'),
      dummyChild:'',
      benefitList: [],
      isBenefitListLoaded: false,
      companyId: null
    };
    this.logout = this.logout.bind(this);
  }

  handleChange(value, key) {
    let cal_http_https = window.API_URL.search('https') === -1 ? 'http' : 'https';
    let api_url = window.API_URL;
    let cal_url = api_url.replace('/v1/', '');
    console.log(`selected ${value}`);
    window.axios.defaults.headers.common['X-COMPANY-ID'] = value;
    sessionStorage.setItem('company_id', value);
    sessionStorage.setItem('company_name', key.props.companyName);
    sessionStorage.setItem('is_child_company', JSON.stringify(key.props.isChildCompany));
    window.location = window.location;
    sessionStorage.setItem(
      'calendar_url',
      cal_url.replace(cal_http_https, 'webcal') + '/calendar/' + key.props.calendarToken + '/calendar.ics'
    );
  }

  handleBlur() {
    console.log('blur');
  }

  handleFocus() {
    console.log('focus');
  }

  getHelpData = async () => {
    await HelpApi.help_request(
      {},
      (res) => this.setState({ help_data: res.data }),
      (err) => handleAppError(err)
    );
  };

  getDigitizationFlag = async () => {
    await utilizationApi.fetchContracts(
      {},
      (res) => {
        if (res.data && res.data.length > 0) {
          let digitization = res.data[0].digitization;
          let isOPDAccount = res.data[0].enable_spending_account;
          sessionStorage.setItem('digitization', digitization);
          sessionStorage.setItem('contract_id', res.data[0].id);
          sessionStorage.setItem('isOPDAccount', isOPDAccount);
          this.setState({ digitization: digitization });
        }
      },
      (err) => {
        handleAppError(err);
      }
    );
  }
  componentDidMount() {
    let is_collapsed = sessionStorage.getItem('collapsed');
    is_collapsed === 'true' ? this.setState({ collapsed: true }) : this.setState({ collapsed: false });

    this.getHelpData();
    this.getDigitizationFlag();
  }

  componentDidUpdate(prevProps, prevState){
    const currentCompanyId = sessionStorage.getItem('company_id');
  
    if (prevState.companyId !== currentCompanyId) {
      this.setState({ companyId: currentCompanyId }, function(){
        this.fetchBenefitList(currentCompanyId);
      })
    }

    let digitization_flag = sessionStorage.getItem('digitization');
    if (digitization_flag!== this.state.digitization){
      this.setState({digitization : digitization_flag });
    }
  }

  fetchBenefitList = (companyId) => {
    if (companyId) {
      utilizationApi.fetchUtilizationBenefitList(
        { companyId: companyId },
        (response) => {
          response?.data?.benefits &&
            this.setState({
              benefitList: response.data.benefits,
              isBenefitListLoaded: true,
            });
        },
        (error) => {
          console.error("Error fetching benefit list:", error);
        },
      );
    }
  };

  updateCollapse = () => {
    this.setState({ collapsed: false }, function () {
      sessionStorage.setItem('collapsed', false);
    });
  };

  toggleCollapse = () => {
    this.setState({ collapsed: !this.state.collapsed }, function () {
      sessionStorage.setItem('collapsed', this.state.collapsed);
    });
  };

  toggle = () => {
    this.setState({ collapsed: !this.state.collapsed }, function () {
      sessionStorage.setItem('collapsed', this.state.collapsed);
    });
  };

  logout = () => {
    sessionStorage.removeItem('company_id');
    sessionStorage.clear();
    this.setState({ redirect: true });
  };

  handleTabChange = (e) => {
    sessionStorage.setItem('defaultSelectedTab', e.key);
  };

  showCompany() {
    if (this.state.role === 'Broker' || this.state.role === 'CSM' || this.state.role === 'CSMMaster') {
      return (
        <span style={{ paddingLeft: 12 }}>
          <Select
            showSearch
            style={{ width: 250, backgroundColor: '#fff' }}
            value={parseInt(sessionStorage.getItem('company_id'))}
            placeholder='Select a company'
            optionFilterProp='children'
            onChange={this.handleChange}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          >
            
            {JSON.parse(sessionStorage.getItem('companies')).map((key) => {
              return (
                <Option value={key.id} companyName={key.name} isChildCompany={key.parent_company_id} calendarToken={key.calendar_token}>
                  {key.name}
                </Option>
              );
            })}
          </Select>
        </span>
      );
    }
  }

  showRightMenu() {
    return (
      <div style={{ float: 'right' }}>
        <Button
          type='primary'
          shape='circle'
          style={{ right: '5px', backgroundColor: '#2168F3', color: 'white' }}
          disabled='false'
        >
          {sessionStorage.getItem('hr_name')[0]}
        </Button>
        <Dropdown
          overlay={this.showMenu()}
          style={{
            color: '#1890ff',
            position: 'fixed',
            right: 0,
            paddingTop: 4,
          }}
        >
          <a className='ant-dropdown-link' href='#'>
            {sessionStorage.getItem('hr_name')} <Icon type='down' />
          </a>
        </Dropdown>
      </div>
    );
  }

  showMenu() {
    if (
      this.state.role !== 'regional_staff' &&
      this.state.role !== 'Broker' &&
      this.state.role !== 'PreEmp' &&
      this.state.role !== 'PreEmpRequest' &&
      this.state.role !== 'CSM' &&
      this.state.role !== 'CSMMaster'
    ) {
      return (
        <Menu>
          <Menu.Item key='2'>
            <span>{sessionStorage.getItem('hr_email')}</span>
          </Menu.Item>
          {/* <Menu.Item key='0'>
            <Link to='/account-managers'>
              <span>Help</span>
            </Link>
          </Menu.Item> */}
          <Menu.Item key='1' onClick={this.logout}>
            <a href='' onClick={this.logout}>
              Logout
            </a>
          </Menu.Item>
        </Menu>
      );
    } else {
      return (
        <Menu>
          <Menu.Item key='1'>
            <span>{sessionStorage.getItem('hr_email')}</span>
          </Menu.Item>
          <Menu.Item key='0' onClick={this.logout}>
            <a href='#' onClick={this.logout}>
              Logout
            </a>
          </Menu.Item>
        </Menu>
      );
    }
  }

  renderPreEmpMenu() {
    let show_pre_emp = sessionStorage.getItem('showPreEmp');
    if (show_pre_emp === 'true') {
      return (
        <Menu.Item key='8'>
          <Link to='/pre-employee-checkup'>
            <Icon type='user-add' />
            <span>Pre Emp Checkup</span>
          </Link>
        </Menu.Item>
      );
    } else {
      return <div />;
    }
  }

  renderCalendar() {
    if (this.state.role !== 'regional_staff' && this.state.role !== 'Broker' && this.state.role !== 'PreEmp' && this.state.role !== 'PreEmpRequest') {
      return (
        <Menu.Item key='20'>
          <Link to='/wellness-calendar'>
            <Icon type='calendar' />
            <span>Wellness Calendar</span>
          </Link>
        </Menu.Item>
      );
    } else {
      return <div />;
    }
  }

  renderOverview() {
    if (this.state.role !== 'regional_staff' && this.state.role !== 'PreEmp' && this.state.role !== 'PreEmpRequest') {
      return (
        <Menu.Item key='9'>
          <Link to='/overview'>
            <Icon type='schedule' />
            <span>Overview</span>
          </Link>
        </Menu.Item>
      );
    } else {
      return <div />;
    }
  }

  renderLaunchActivities() {
    if (
      this.state.role !== 'regional_staff' &&
      this.state.role !== 'Broker' &&
      this.state.role !== 'PreEmp' &&
      this.state.role !== 'PreEmpRequest' &&
      this.state.role !== 'CSM' &&
      this.state.role !== 'CSMMaster'
    ) {
      return (
        <SubMenu
          key='sub3'
          title={
            <span>
              <Icon type='rocket' theme='outlined' />
              <span>Launch Activities</span>
            </span>
          }
        >
          <Menu.Item key='10'>
            <Link to='/pre-registration'>
              <Icon type='user-add' />
              <span>Pre Registration</span>
            </Link>
          </Menu.Item>
        </SubMenu>
      );
    } else {
      return <div />;
    }
  }

  renderServicers() {
    if (this.state.role !== 'regional_staff' && this.state.role !== 'Broker' && this.state.role !== 'PreEmp' && this.state.role !== 'PreEmpRequest') {
      return (
        <SubMenu
          key='sub6'
          title={
            <span>
              <Icon type='global' theme='outlined' />
              <span>Services</span>
            </span>
          }
        >
          <Menu.Item key='11'>
            <Link to='/customer-appointments'>
              <Icon type='schedule' theme='outlined' />
              <span>Appointments</span>
            </Link>
          </Menu.Item>
        </SubMenu>
      );
    } else {
      return <div />;
    }
  }

  renderEngaments() {
    if (this.state.role !== 'regional_staff' && this.state.role !== 'Broker' && this.state.role !== 'PreEmp' && this.state.role !== 'PreEmpRequest') {
      return (
        <SubMenu
          key='sub5'
          title={
            <span>
              <Icon type='team' theme='outlined' />
              <span>Engagement</span>
            </span>
          }
        >
          <Menu.Item key='12'>
            <Link to='/facilities'>
              <Icon type='ordered-list' theme='outlined' />
              <span>Activities</span>
            </Link>
          </Menu.Item>
        </SubMenu>
      );
    } else {
      return <div />;
    }
  }

  renderLogo() {
    if (this.state.collapsed) {
      return (
        <img
          src='https://res.cloudinary.com/ekincare/image/upload/v1541072851/hr_dashboard_login_page/logo_icon.svg'
          alt=''
        />
      );
    } else {
      return (
        <img
          src='https://res.cloudinary.com/ekincare/image/upload/v1541074570/hr_dashboard_login_page/ekincare-logo-new-white.svg'
          alt=''
        />
      );
    }
  }

  renderCSM() {
    if (this.state.role === 'CSMMaster') {
      return (
        <Menu.Item key='14'>
          <Link to='/account-managers'>
            <Icon type='user' />
            <span>CSM</span>
          </Link>
        </Menu.Item>
      );
    }
  }

  renderEmployeeData() {
    if (
      this.state.role !== 'regional_staff' &&
      this.state.role !== 'Broker' &&
      this.state.role !== 'PreEmp' &&
      this.state.role !== 'PreEmpRequest' &&
      this.state.role !== 'CSM' &&
      this.state.role !== 'CSMMaster'
    ) {
      return (
        <SubMenu
          key='sub6'
          title={
            <span>
              <Icon type='rocket' theme='outlined' />
              <span>Employee Data</span>
            </span>
          }
        >
          <Menu.Item key='15' style={{ height: 'auto' }}>
            <Link to='/employee-registration'>
              <div style={{ lineHeight: 'normal', margin: '7% auto 7% auto' }}>
                <div>Employee</div>
                <div>Registration</div>
              </div>
            </Link>
          </Menu.Item>{' '}
          <Menu.Item key='16'>
            <Link to='/delete-employees'>
              <span>Delete Employees</span>
            </Link>
          </Menu.Item>
          <Menu.Item key='17'>
            <Link to='/update-employees'>
              <span>Update Employees</span>
            </Link>
          </Menu.Item>
          <Menu.Item key='18'>
            <Link to='/family-registration'>
              <span>Family Registration</span>
            </Link>
          </Menu.Item>
        </SubMenu>
      );
    } else {
      return <div />;
    }
  }

  toggleHelpDrawer = (initialKey) => {
    this.setState({ drawerflag: !this.state.drawerflag, initialKey: initialKey });
  };
  render() {
    const { benefitList, isBenefitListLoaded} = this.state;
    return (
      <SideBar previousState={this.state} benefitList={benefitList} isBenefitListLoaded={isBenefitListLoaded}>
        <NavBar
          previousState={this.state}
          initialKey={this.state.initialKey}
          showhelp={this.state.drawerflag}
          toggleHelp={this.toggleHelpDrawer}
          getDigitizationFlag= {this.getDigitizationFlag}
          fetchBenefitList={this.fetchBenefitList}
          that={this}
        />
        <Content
          id='contentScreen'
          style={{ backgroundColor: '#f6f7f9' }}
          className='mt-16 p-6'
        >
          {React.createElement(this.state.dummyChild || this.props.child, {
            ...this.props,
            toggleHelp: this.toggleHelpDrawer,
          })}
        </Content>
      </SideBar>
    );

  }
}
export default MainLayout;
